/**
 * Обрабатывает ошибки, возникающие при выполнении HTTP-запросов.
 * В зависимости от типа ошибки (ошибка сервера, ошибка запроса или другая ошибка),
 * функция логирует сообщение об ошибке и пробрасывает её дальше.
 */
export function handleRequestError(error) {
  if (error.response) {
    // Ошибка от сервера (например, 4xx или 5xx)
    console.error("Сервер ответил с ошибкой:", error.response.data);
    throw error; // Пробрасываем ошибку, чтобы сохранить response
  } else if (error.request) {
    // Ошибка запроса (например, нет ответа от сервера)
    console.error("Ответ не был получен:", error.request);
    throw new Error("Ответ от сервера не был получен");
  } else {
    // Другие ошибки (например, ошибка в настройке запроса)
    console.error("Ошибка при настройке запроса:", error.message);
    throw new Error("Ошибка при настройке запроса: " + error.message);
  }
}
